/** Mimics `fetch` resolving to a JSON body for Home’s `safeJson` / `Response` handling. */
export function mockJsonResponse(data: unknown): Response {
  return new Response(JSON.stringify(data), {
    status: 200,
    headers: { 'Content-Type': 'application/json' },
  })
}
